import apiClient from './config'; // Adjust path to point to your config file

// URL prefix (matches your backend route: /api/exams)
const EXAM_URL = '/exams'; 

// --- GET ALL EXAMS ---
export const fetchExams = async () => {
  try {
    const response = await apiClient.get(EXAM_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// --- CREATE NEW EXAM ---
export const createExam = async (examData) => {
  try {
    // examData should be: { subjectCode, title, description, appearance: { color, icon } }
    // Note: We need to structure the payload to match what the Controller expects
    const payload = {
      subjectCode: examData.subjectCode,
      title: examData.title,
      description: examData.description,
      color: examData.color, // Controller expects 'color' at root or inside appearance logic
      icon: examData.icon
    };

    const response = await apiClient.post(EXAM_URL, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// --- UPDATE EXAM ---
export const updateExam = async (examId, examData) => {
  try {
    const payload = {
      subjectCode: examData.subjectCode,
      title: examData.title,
      description: examData.description,
      color: examData.color,
      icon: examData.icon
    };

    // Assuming your backend expects a PUT request to /exams/:id
    const response = await apiClient.put(`${EXAM_URL}/${examId}`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// --- DELETE EXAM ---
export const deleteExam = async (examId) => {
  try {
    // Assuming your backend expects a DELETE request to /exams/:id
    const response = await apiClient.delete(`${EXAM_URL}/${examId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};